module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-mg-slot.c88f23c2.png";